import {
	ProSidebar,
	Menu /* , SubMenu*/,
	MenuItem,
	SidebarHeader,
	SidebarContent,
} from 'react-pro-sidebar';
import React from 'react';
import 'react-pro-sidebar/dist/css/styles.css';
import { Link } from 'react-router-dom';
import { ImDatabase } from 'react-icons/im';
import { FaUserLock } from 'react-icons/fa';
import { HiDocumentReport } from 'react-icons/hi';
import { GiHamburgerMenu } from 'react-icons/gi';

const Sidebar = ({ toggled, setToggled, admin, projectId }) => {
	return (
		<div>
			<div id='navbar-container'>
				<ProSidebar
					width='220px'
					breakPoint='sm'
					toggled={toggled}
					onToggle={(val) => setToggled(val)}
					id='react-pro-sidebar'>
					<SidebarHeader
						style={{ textAlign: 'center', padding: '0px', margin: '0px' }}
						id='react-pro-sidebar-header'>
						<Link to='/'>
							<img
								style={{
									height: '50px',
									objectFit: 'contain',
									width: '5rem',
								}}
								src={
									'https://images.unsplash.com/photo-1629080165171-24bec779fb99?ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMnx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=60'
								}
								alt='logo'
							/>
						</Link>
					</SidebarHeader>

					<SidebarContent id='react-pro-sidebar-content'>
						<Menu
							id='react-pro-sidebar-menu'
							iconShape='circle'
							popperArrow={true}>
							<MenuItem
								className='react-pro-sidebar-menu-item'
								icon={<i className='fas fa-home'></i>}>
								Main Dashboard <Link to='/main/dashboard' />
							</MenuItem>

							<MenuItem
								className='react-pro-sidebar-menu-item'
								icon={<i className='fas fa-home'></i>}>
								Drive Dashboard <Link to='/drive/main/dashboard' />
							</MenuItem>

							{projectId ? (
								<div>
									<MenuItem
										className='react-pro-sidebar-menu-item'
										icon={<HiDocumentReport />}>
										Report Setting
										<Link to={`/reports/project/${projectId}`} />
									</MenuItem>
									<MenuItem
										className='react-pro-sidebar-menu-item'
										icon={<FaUserLock />}>
										Account Setting
										<Link to={`/accounts/project/${projectId}`} />
									</MenuItem>
									<MenuItem
										className='react-pro-sidebar-menu-item'
										icon={<ImDatabase />}>
										Database Setting{' '}
										<Link to={`/databases/project/${projectId}`} />
									</MenuItem>{' '}
								</div>
							) : null}
						</Menu>
					</SidebarContent>
				</ProSidebar>
			</div>
			<div className='navbar-for-mobile'>
				<a
					style={{
						height: '50px',
						zIndex: '200',
						position: 'absolute',
						marginLeft: '1rem',
						marginTop: '0.5rem',
					}}
					data-bs-toggle='offcanvas'
					href='#offCanvasId'
					role='button'
					aria-controls='offCanvasId'>
					<GiHamburgerMenu size='2rem' color='white' />
				</a>
				<div
					className='offcanvas offcanvas-start'
					tabIndex='-1'
					id='offCanvasId'
					aria-labelledby='offCanvasLabel'>
					<div className='offcanvas-header'>
						<h5 id='offCanvasLabel'></h5>
						<button
							type='button'
							className='btn-close text-reset'
							data-bs-dismiss='offcanvas'
							aria-label='Close'></button>
					</div>
					<div className='offcanvas-body'>
						<ul style={{ listStyle: 'none' }}>
							<li>
								<i className='fas fa-home'></i>
								<Link to='/main/dashboard'> Main Dashboard </Link>
							</li>
							{projectId ? (
								<div>
									<li>
										<HiDocumentReport />
										<Link to={`/reports/project/${projectId}`}>
											{' '}
											Report Setting
										</Link>
									</li>
									<li>
										<FaUserLock />
										<Link to={`/accounts/project/${projectId}`}>
											{' '}
											Account Setting{' '}
										</Link>
									</li>
									<li>
										<ImDatabase />
										<Link to={`/databases/project/${projectId}`}>
											{' '}
											Database Setting
										</Link>
									</li>
								</div>
							) : null}
						</ul>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
